/* eslint-disable max-len */
import axios from "axios";
import { useMemo, useState, useContext, useRef, useEffect } from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate } from "react-router-dom";
import AllCompetenciesList from "../../components/AllCompetenciesList";
import SearchCompetencies from "../../components/SearchCompetencies";
import { UserContext } from "../../context/UserContext";
import AllVersionsList from "../../components/AllVersionsList";
import { EmptyVersion, VersionType } from "../../types/Version";
import { VersionContext } from "../../context/VersionContext";

interface Props {
  isSuperUser: boolean;
}
function SelectVersion(props: Props) {
  const { isSuperUser } = props;
  const [versions, setVersions] = useState<Array<VersionType>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const versionContext = useContext(VersionContext);
  const universityCode = localStorage.getItem("university") || "";
  const navigate = useNavigate();
  const [selectedProgram, setSelectedProgram] = useState(() => {
    return localStorage.getItem("selectedProgram") || "";
  });

  useEffect(() => {
    if (universityCode && selectedProgram) {
      fetchVersions(universityCode, selectedProgram);
    }
  }, [selectedProgram, universityCode]);
  const fetchVersions = (university: string, program: string) => {
    axios
      .get(`/version?university_code=${university}&program_name=${program}`)
      .then((res) => {
        if (res.data.versions) {
          setVersions(res.data.versions);
        }
        setLoading(false);
      })
      .catch((err: any) => {
        setVersions([]);
        setLoading(false);
        if (err?.response?.data?.message === "missing or malformed jwt") {
          window.location.pathname = "/signin";
        }
      });
  };
  const adoptVersion = (version: VersionType) => {
    axios
      .get(`/version?university_code=${universityCode}`)
      .then((res) => {
        if (res.data.versions) {
          setVersions(res.data.versions);
        }
        setLoading(false);
      })
      .catch(() => {
        setVersions([]);
        setLoading(false);
      });
  };

  return (
    <>
      <AllVersionsList
        isSuperUser={isSuperUser}
        mode="select"
        data={versions}
        fetchParent={fetchVersions}
        onDeselect={(selectedVersion: VersionType) => {
          if (selectedVersion.university !== "") {
            versionContext.setCurrentVersion(EmptyVersion);
          }
        }}
        onSelect={(selectedVersion: VersionType) => {
          if (selectedVersion.university !== "") {
            versionContext.setCurrentVersion(selectedVersion);
          }
        }}
        onAdopt={(selectedVersion: VersionType) => {
          if (selectedVersion.university !== "") {
            console.log(selectedVersion);
          }
        }}
        onDraft={(selectedVersion: VersionType) => {
          if (selectedVersion.university !== "") {
            console.log(selectedVersion);
          }
        }}
        onDelete={(selectedVersion: VersionType) => {
          if (selectedVersion.university !== "") {
            console.log(selectedVersion);
          }
        }}
      />
    </>
  );
}
export default SelectVersion;
